import { FC } from "react";
import { VoidFunc } from "../../helpers/functions/types";
import { AttributeGroupWrapper } from "../../ui/layout/detailedPages/AttributeGroupWrapper";
import { useAppSelector } from "../../store";
import { DETAILS_SECTION_STYLES } from "../../ui/layout/detailedPages/styles";

type VpdAttributesWrapperProps = {
  productAttributes?: string[];
  setProductAttributes: VoidFunc<string[]>;
  imageAttributes?: string[];
  setImageAttributes: VoidFunc<string[]>;
  isNewPage?: boolean;
};

export const VpdAttributesWrapper: FC<VpdAttributesWrapperProps> = ({
  productAttributes = [],
  setProductAttributes,
  imageAttributes = [],
  setImageAttributes,
  isNewPage,
}) => {
  const attributes = useAppSelector((state) => state.campaigns.attributes);

  return (
    <div className={isNewPage ? DETAILS_SECTION_STYLES : "grid gap-6 p-4"}>
      <AttributeGroupWrapper
        initAttributesGroup={productAttributes}
        handleAttributesGroup={setProductAttributes}
        groupAttributesList={attributes.productAttributes}
        attributeGroupTitle="Product Attributes"
        isNewPage={isNewPage}
      />

      <AttributeGroupWrapper
        initAttributesGroup={imageAttributes}
        handleAttributesGroup={setImageAttributes}
        groupAttributesList={attributes.imageAttributes}
        attributeGroupTitle="Image Attributes"
        isNewPage={isNewPage}
      />
    </div>
  );
};
